import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/typeof";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import merge from 'lodash.merge';
import FieldPassContainer from './FieldPassContainer';
import NavSide from './NavSide';
import NavTop from './NavTop';
import HeaderStyle from './HeaderStyle';
import { HeaderGlobalStyles } from './GlobalStyles';
import { addTracking, makeTrackingCall } from '../scripts/tracking';
import { getActiveSection, transformTeamsData, transformHeaderData, modelStyleProps } from '../scripts/dataModel';
var DefaultCopyConfig = {
  closeLabel: 'Close',
  loginTitle: 'Log In',
  registerTitle: 'Register'
};
var DefaultLoginConfig = {
  copyConfig: {
    usernamePlaceholder: 'Email',
    passwordPlaceholder: 'Password',
    submitButton: 'Log In',
    helpLink: 'Need help logging in?',
    registerLabel: "Don't have an account?",
    registerLink: 'Sign up',
    errorMessage: 'There was an error. Please try again'
  }
};
var DefaultRegisterConfig = {
  copyConfig: {
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Create Password',
    confirmPasswordPlaceholder: 'Repeat Password',
    birthdayLabel: 'Date of Birth',
    monthPlaceholder: 'MM',
    dayPlaceholder: 'DD',
    yearPlaceholder: 'YYYY',
    // optInLabel:
    //     'I would like to receive commercial e-mails from MLB.com and their partners.',
    // policyLabel:
    //     'I understand and agree to be bound by the MLB.com Terms of Use and Privacy Policy.',
    submitButton: 'Register',
    loginLabel: 'Already have an account?',
    loginLink: 'Log In'
  }
};

/**
 * Get the height of the container defined by topAdContainer input.
 * The returned value is used to set the top position of the left side nav.
 * useCalculatedTopSideNav and useFixedTopSideNav props must both be set to true to use this function
 * @param topAdContainer (as string) is the css selector (e.g. '.p-ad.ad-responsive-slot') of the container
 * @returns height (as number) of the container as defined by the topAdContainer css selector
 */

var getTopAdHeight = function getTopAdHeight(topAdContainer) {
  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object' || !document.querySelector(topAdContainer)) {
    return 0;
  }
  var topAdElement = document.querySelector(topAdContainer);
  var _window$getComputedSt = window.getComputedStyle(topAdElement),
    marginBottom = _window$getComputedSt.marginBottom,
    marginTop = _window$getComputedSt.marginTop;
  var margin = parseFloat(marginTop) + parseFloat(marginBottom);
  return topAdElement.offsetHeight + (margin || 0);
};
var Header = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);
  var _super = _createSuper(Header);
  function Header(props) {
    var _this;
    _classCallCheck(this, Header);
    _this = _super.call(this, props);
    _this.state = {
      navSideOpen: false,
      isFieldPassOpen: false
    };
    _this.menuToggle = _this.menuToggle.bind(_assertThisInitialized(_this));
    _this.closeMenu = _this.closeMenu.bind(_assertThisInitialized(_this));
    _this.dataAttributes = _this.dataAttributes.bind(_assertThisInitialized(_this));
    _this.headerRef = /*#__PURE__*/React.createRef();
    _this.onFieldPassClose = _this.onFieldPassClose.bind(_assertThisInitialized(_this));
    _this.setFieldPassOpen = _this.setFieldPassOpen.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Header, [{
    key: "setFieldPassOpen",
    value: function setFieldPassOpen(status) {
      this.setState({
        isFieldPassOpen: status
      });
    }
  }, {
    key: "onFieldPassClose",
    value: function onFieldPassClose() {
      this.setFieldPassOpen(false);
    }
  }, {
    key: "toggleBodyClass",
    value: function toggleBodyClass() {
      if (this.state.navSideOpen) {
        document.body.classList.add('side-nav-open');
      } else {
        document.body.classList.remove('side-nav-open');
      }
    }
  }, {
    key: "menuToggle",
    value: function menuToggle() {
      this.setState(function (prevState) {
        var prop14 = "Navigation Module: Sidebar: Click / Tap ".concat(!prevState.navSideOpen ? 'Open' : 'Close');
        makeTrackingCall(prop14);
        return {
          navSideOpen: !prevState.navSideOpen
        };
      });
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      this.setState(function (prevState) {
        if (prevState.navSideOpen) {
          var prop14 = 'Navigation Module: Sidebar: Off-Interaction Close';
          makeTrackingCall(prop14);
        }
        return {
          navSideOpen: false
        };
      });
    }
  }, {
    key: "dataAttributes",
    value: function dataAttributes(isClub) {
      if (isClub) {
        return {
          'data-is-club': 'true'
        };
      }
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      addTracking();
      document && document.body.classList.add('has-react-header');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.toggleBodyClass();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        clubId = _this$props.clubId,
        _this$props$contentfu = _this$props.contentfulProps,
        contentfulProps = _this$props$contentfu === void 0 ? {} : _this$props$contentfu,
        fieldPassConfig = _this$props.fieldPassConfig,
        headerData = _this$props.headerData,
        isLoggedIn = _this$props.isLoggedIn,
        isMicrositeIndex = _this$props.isMicrositeIndex,
        locale = _this$props.locale,
        onAuthSuccess = _this$props.onAuthSuccess,
        onLogout = _this$props.onLogout,
        reqPath = _this$props.reqPath,
        sharedNav = _this$props.sharedNav,
        styleProps = _this$props.styleProps,
        teamNameSlug = _this$props.teamNameSlug,
        teamsData = _this$props.teamsData,
        topAdContainer = _this$props.topAdContainer,
        useCalculatedTopSideNav = _this$props.useCalculatedTopSideNav,
        useFieldPass = _this$props.useFieldPass,
        useFixedTopSideNav = _this$props.useFixedTopSideNav,
        useInlineLogout = _this$props.useInlineLogout;
      var _ref = fieldPassConfig || {},
        _ref$copyConfig = _ref.copyConfig,
        copyConfig = _ref$copyConfig === void 0 ? {} : _ref$copyConfig,
        _ref$loginConfig = _ref.loginConfig,
        loginConfig = _ref$loginConfig === void 0 ? {} : _ref$loginConfig,
        _ref$registerConfig = _ref.registerConfig,
        registerConfig = _ref$registerConfig === void 0 ? {} : _ref$registerConfig;
      var combinedCopyConfig = merge(DefaultCopyConfig, copyConfig);
      var combinedLoginConfig = merge(DefaultLoginConfig, loginConfig);
      var combinedRegisterConfig = merge(DefaultRegisterConfig, registerConfig);
      var combinedFieldPassConfig = {
        copyConfig: combinedCopyConfig,
        loginConfig: combinedLoginConfig,
        registerConfig: combinedRegisterConfig
      };
      var _headerData$menuItems = headerData.menuItems,
        menuItems = _headerData$menuItems === void 0 ? [] : _headerData$menuItems,
        _headerData$variables = headerData.variables,
        navVariables = _headerData$variables === void 0 ? [] : _headerData$variables;
      var isClub = !['mlb', 'milb'].includes(clubId);
      var teamNameDisplay = contentfulProps.teamNameDisplay,
        _contentfulProps$pale = contentfulProps.palette,
        _contentfulProps$pale2 = _contentfulProps$pale === void 0 ? {} : _contentfulProps$pale,
        headerNavigationTextColor = _contentfulProps$pale2.headerNavigationTextColor,
        headerNavigationTextColorHover = _contentfulProps$pale2.headerNavigationTextColorHover;
      var teamData = transformTeamsData(teamsData, locale);
      var currentSection = getActiveSection(reqPath, menuItems, isMicrositeIndex);
      var _modelStyleProps = modelStyleProps(contentfulProps, clubId),
        clubProps = _modelStyleProps.clubProps,
        theme = _modelStyleProps.theme;
      var classes = classnames({
        'mlb-header': true,
        'mlb-header--side-nav-open': this.state.navSideOpen,
        'mlb-header--side-nav-closed': !this.state.navSideOpen
      });
      var navItems = transformHeaderData({
        navItems: menuItems,
        sharedNav: sharedNav,
        teamNameSlug: teamNameSlug,
        locale: locale,
        teamData: teamData,
        currentSection: currentSection
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderStyle, {
        theme: theme
      }, /*#__PURE__*/React.createElement(HeaderGlobalStyles, {
        topAdHeight: useCalculatedTopSideNav ? getTopAdHeight(topAdContainer) : 0,
        useFixedTopSideNav: useFixedTopSideNav
      }), /*#__PURE__*/React.createElement("header", _extends({
        className: classes
      }, this.dataAttributes(isClub), {
        ref: this.headerRef
      }), /*#__PURE__*/React.createElement("div", {
        className: "mlb-header--inner"
      }, /*#__PURE__*/React.createElement(NavTop, {
        closeMenu: this.closeMenu,
        clubId: clubId,
        clubProps: clubProps,
        headerNavigationTextColor: headerNavigationTextColor,
        headerNavigationTextColorHover: headerNavigationTextColorHover,
        isClub: isClub,
        isLoggedIn: isLoggedIn,
        locale: locale,
        isFieldPassOpen: this.state.isFieldPassOpen,
        menuToggle: this.menuToggle,
        navItems: navItems,
        navSideOpen: this.state.navSideOpen,
        navVariables: navVariables,
        onLogout: onLogout,
        setFieldPassOpen: this.setFieldPassOpen,
        styleProps: styleProps,
        teamNameSlug: teamNameSlug,
        teamNameDisplay: teamNameDisplay,
        useFieldPass: useFieldPass,
        useInlineLogout: useInlineLogout
      }), /*#__PURE__*/React.createElement(NavSide, {
        locale: locale,
        navSideOpen: this.state.navSideOpen,
        closeMenu: this.closeMenu,
        teamNameDisplay: teamNameDisplay,
        isClub: isClub,
        navSideItems: navItems
      })))), useFieldPass && /*#__PURE__*/React.createElement(FieldPassContainer, {
        config: combinedFieldPassConfig,
        isLoggedIn: isLoggedIn,
        isOpen: this.state.isFieldPassOpen,
        onAuthSuccess: onAuthSuccess,
        onClose: this.onFieldPassClose
      }));
    }
  }]);
  return Header;
}(React.Component);
export default Header;
Header.propTypes = {
  clubId: PropTypes.string,
  contentfulProps: PropTypes.shape({
    properties: PropTypes.shape({}),
    palette: PropTypes.shape({})
  }),
  fieldPassConfig: PropTypes.shape({
    copyConfig: PropTypes.shape({}),
    loginConfig: PropTypes.shape({}),
    registerConfig: PropTypes.shape({})
  }),
  headerData: PropTypes.shape({
    menuItems: PropTypes.instanceOf(Array),
    variables: PropTypes.instanceOf(Array)
  }).isRequired,
  isLegacy: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isMicrositeIndex: PropTypes.bool,
  locale: PropTypes.string,
  onAuthSuccess: PropTypes.func,
  onLogout: PropTypes.func,
  reqPath: PropTypes.string,
  sharedNav: PropTypes.shape({}),
  styleProps: PropTypes.shape({}),
  teamNameSlug: PropTypes.string,
  teamsData: PropTypes.instanceOf(Array),
  topAdContainer: PropTypes.string,
  useCalculatedTopSideNav: PropTypes.bool,
  useFixedTopSideNav: PropTypes.bool,
  useFieldPass: PropTypes.bool,
  useInlineLogout: PropTypes.bool
};
Header.defaultProps = {
  clubId: 'mlb',
  contentfulProps: {},
  fieldPassConfig: {},
  headerData: {
    menuItems: []
  },
  isLegacy: false,
  isLoggedIn: false,
  isMicrositeIndex: false,
  locale: 'en',
  onAuthSuccess: function onAuthSuccess() {},
  onLogout: function onLogout() {},
  sharedNav: {},
  teamNameSlug: '',
  topAdContainer: '.p-ad.ad-responsive-slot.ad-redesign',
  useCalculatedTopSideNav: false,
  useFixedTopSideNav: false,
  useFieldPass: false,
  useInlineLogout: false
};